import { updateItems, commentItems } from '@/mocks/homeData';

function SectionTitle({ title, subtitle }: { title: string; subtitle: string }) {
  return (
    <div className="text-center mb-10 md:mb-14">
      <h2 className="text-2xl md:text-3xl font-black text-foreground-950 tracking-tight">
        {title}
      </h2>
      <p className="mt-3 text-sm md:text-base text-foreground-500">{subtitle}</p>
    </div>
  );
}

export function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="mx-auto max-w-[800px]">
        <SectionTitle
          title="最新动态"
          subtitle="苹果视频平台更新与内容同步，不错过每一条重要消息"
        />
        <div className="relative">
          <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-400/30 hidden sm:block"></div>
          <div className="flex flex-col gap-4">
            {updateItems.map((item) => (
              <div key={item.id} className="flex gap-4 sm:gap-6">
                <div className="hidden sm:flex flex-col items-center pt-1">
                  <div className="w-[10px] h-[10px] rounded-full bg-primary-500 flex-shrink-0"></div>
                </div>
                <div className="flex-1 bg-background-200/80 rounded-xl border border-background-400/30 p-4 sm:p-5 hover:border-primary-500/20 transition-all duration-200">
                  <span className="inline-block px-2.5 py-1 rounded bg-primary-500/10 text-primary-400 text-xs font-mono mb-2">
                    {item.date}
                  </span>
                  <h3 className="text-sm md:text-base font-bold text-foreground-800">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="mx-auto max-w-[1000px]">
        <SectionTitle
          title="用户好评"
          subtitle="来自真实用户的观影反馈，听听他们怎么说"
        />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {commentItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-200/80 rounded-xl border border-background-400/30 p-5 sm:p-6"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`ri-star-fill text-sm ${
                      i < item.rating ? 'text-accent-400' : 'text-background-500'
                    }`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                &ldquo;{item.text}&rdquo;
              </p>
              <div className="flex items-center justify-between pt-4 border-t border-background-400/20">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-full bg-primary-500/15 flex items-center justify-center">
                    <span className="text-xs font-bold text-primary-400">
                      {item.name.charAt(0)}
                    </span>
                  </div>
                  <span className="text-sm font-semibold text-foreground-700 whitespace-nowrap">
                    {item.name}
                  </span>
                </div>
                <span className="text-xs text-foreground-500 font-mono">{item.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}